<template>
  <router-link
    class="text-dark"
    style="text-decoration: none;"
    :disabled="disabled"
    :event="!disabled ? 'click' : ''"
    :style="disabled ? 'cursor: default' : ''"
    :to="to">
    <b-card @click="click">
      <slot name='header' slot="header" />
      <slot />
    </b-card>
  </router-link>
</template>
<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    to: {
      type: [String, Object],
      required: true
    }
  },

  methods: {
    click() {
      if (this.disabled) {
        this.$emit('disabledClick');
      }
    }
  }
}
</script>
